import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from './BaseQueryWithReauth';

export const api = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
}).enhanceEndpoints({
  addTagTypes: ['Addon', 'AppointmentGroup', 'Appointment', 'Industry', 'User', 'Lead', 'Client', 'Booking'],
});
